module.exports = __webpack_public_path__ + "img/germany.e63d59ee.png";